import { render } from "./DashboardSkeleton.vue?vue&type=template&id=6723ef15&scoped=true"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js"

import "./DashboardSkeleton.vue?vue&type=style&index=0&id=6723ef15&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6723ef15"]])

export default __exports__